<template>
  <specialist-certification-finding :full-profile="fullProfile" />
</template>

<script>
import { SpecialistCertificationFinding } from 'appointment-management';
import { name as userModuleName } from '@/modules/user/store';
import { mapGetters } from 'vuex';

export default {
  name: 'SpecialistCertificationFindingWrapper',
  components: {
    SpecialistCertificationFinding,
  },
  computed: {
    ...mapGetters(userModuleName, ['fullProfile']),
  },
};
</script>
